export default {
  enterToSend: 'Nhấn Enter để gửi',
  noHistoryAvailable: 'Không có lịch sử',
  listOfBookingSystems: ' Danh sách hệ thống đặt vé',
  send: 'Gửi',
  deleteHistory: 'Xoá lịch sử',
}
